<div class="toolbar-grid">
  <div class="layout-row">
    <h3-secondary-toolbar-2d-objectless
      *h3Injector="contentInjector"
    ></h3-secondary-toolbar-2d-objectless>
    <h3-edit-mode-button *h3Injector="contentInjector"></h3-edit-mode-button>
    <div class="output-controls">
      <h3-raster-coding-layer-view-settings *h3Injector="contentInjector">
      </h3-raster-coding-layer-view-settings>

      <h3-undo-redo-buttons
        *ngIf="(readOnly$ | async) !== true"
      ></h3-undo-redo-buttons>

      <h3-help-button></h3-help-button>
    </div>
  </div>
  <div class="layout-row">
    <h3-main-raster-coding-toolbar
      *h3Injector="contentInjector"
    ></h3-main-raster-coding-toolbar>
    <h3-tag-option-list *h3Injector="contentInjector"></h3-tag-option-list>
  </div>
  <h3-coordinates-box *h3Injector="contentInjector"></h3-coordinates-box>
</div>
